
import { selectIsConfirmationErrorModalOpen } from "features/common/model/selectors/appSelectors"
import {
  AUTH_MODAL_MODE,
  setAuthModalMode,
  setIsAuthModalOpen,
  setIsConfirmationErrorModalOpen
} from 'features/common/model/slice/appSlice'
import { useAppDispatch, useAppSelector } from 'shared/config/store'
import { CloseCircleFilled, Flex, Modal, Typography } from "shared/ui"
import styled from "styled-components"
import { useNavigate } from 'react-router-dom'

export const ConfirmationByLinkErrorModal = () => {
  const isConfirmationErrorModalOpen = useAppSelector(selectIsConfirmationErrorModalOpen)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleClose = () => {
    return false
  }

  const handleSignUp = () => {
    navigate('/')
    dispatch(setIsConfirmationErrorModalOpen(false))
    dispatch(setAuthModalMode(AUTH_MODAL_MODE.SIGNUP))

    dispatch(setIsAuthModalOpen(true))
  }


  return (
    <Modal
      open={isConfirmationErrorModalOpen}
      footer={null}
      width={420}
      closable={false}
      centered
      destroyOnClose={true}
      onCancel={handleClose}
      styles={{
        mask: {
          backgroundColor: "transparent",
          background: "url('/images/sendToEmailBg.svg')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        },
        content: {
          padding: 48,
        },
      }}
      wrapClassName="signup-confirmation-modal-wrapper"
    >
      <Flex vertical
        align="center"
        gap={24}
      >
        <SuccessIcon>
          <CloseCircleFilled style={{ fontSize: 60, color: "#FF4D4F" }} />
        </SuccessIcon>

        <Typography.Title level={3}
          style={{
            textAlign: "center",
            margin: 0,
            color: "rgba(0, 0, 0, 0.85)",
            fontSize: 24,
            fontWeight: 600,
            lineHeight: "32px" }}
        >
          Confirmation Link Invalid or Already Used
        </Typography.Title>

        <Typography.Text style={{
          textAlign: "center",
          color: "rgba(0, 0, 0, 0.65)",
          fontSize: 14,
          lineHeight: "22px" }}
        >
          It looks like the link you followed is either incorrect or has already been used.

          <br />
          Please check the link and try again, or request a new one if needed.
        </Typography.Text>

        <Typography.Text style={{ textAlign: "center" }}>
          Go to
          {' '}

          <SignUpLink onClick={handleSignUp}>
            Sign up
          </SignUpLink>
        </Typography.Text>
      </Flex>
    </Modal>
  )
}

const SuccessIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 72px;
  height: 72px;
  margin-bottom: 8px;
  padding: 4px;
  box-sizing: border-box;
`

const SignUpLink = styled.span`
  color: #8F4EEB;
  cursor: pointer;
  text-decoration: underline;
`
